import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
axios.defaults.withCredentials = true;

export const client = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
    headers: {
        "Accept": "application/json",
    }
});
   
const setHeaders = () => {
    const token = localStorage.getItem('token');
    
    if (token) {
        client.defaults.headers.common['Authorization'] = `token ${token}`;
    } else {
        delete client.defaults.headers.common['Authorization'];
    }
}

export const webshop = {
    post: (payload) => {
        setHeaders();
        return client.post('', payload)
    }
}

export const method = {
    login: (payload) => client.post('/api/method/arkha.api.auth.login', payload),
    get: (method_name) => {
        setHeaders();
        return client.get('/api/method/' + method_name)
    },
    post: (method_name, payload) => {
        setHeaders();
        return client.post('/api/method/' + method_name, payload)
    }
}

export const resource = {
    get: (doctype, fields = '["*"]', filters) => {
        setHeaders();
        let queryParam = `?fields=${fields}`;
        if (filters) {
            queryParam += `&filters=${filters}`;
        }
        return client.get(`api/resource/${doctype}${queryParam}`, {
            method: 'GET',
            headers: setHeaders(),
        })
    },
    post: (doctype, payload) => {

        setHeaders();
        return client.post(`api/resource/${doctype}`, payload);
    },
    del: (doctype, docname) => {
        setHeaders();
        const url = `api/resource/${doctype}${docname ? `/${docname}` : ''}`;
        return client.delete(url);
    }
}